export default __webpack_public_path__ + "static/icp-acc-02-01-01-53fb03f678c8486e83ad00cd5570017b.png";